import type { SVGProps } from 'react';

const SvgShield2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99996 14.6666C7.99996 14.6666 13.3333 11.9999 13.3333 7.99992V3.33325L7.99996 1.33325L2.66663 3.33325V7.99992C2.66663 11.9999 7.99996 14.6666 7.99996 14.6666Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgShield2;
